import qs from 'qs';
import { useLocation } from 'react-router';

/**
 * All GET params known to this application
 */
interface QueryParams {
	// ID for loading a customizing JSON on startup
	customizingid?: string;
}

/**
 * Returns the query params of the current route
 */
export function useQueryParams(): QueryParams {
	return qs.parse(useLocation().search, {
		ignoreQueryPrefix: true,
	}) as unknown as QueryParams;
}
